import React from 'react';
import { Box, Typography } from '@mui/material';

interface ProgressStatsProps {
  successfulRows: number;
  failedRows: number;
  processedRows: number;
  totalRows: number;
}

/**
 * Displays live counters for import progress: successful, failed, and processed rows.
 */
const ProgressStats: React.FC<ProgressStatsProps> = ({
  successfulRows,
  failedRows,
  processedRows,
  totalRows,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 3,
        flexWrap: 'wrap',
        mt: 2,
      }}
      aria-label="Import statistics"
      aria-live="polite"
      aria-atomic="true"
    >
      <Box>
        <Typography variant="body2" color="text.secondary">
          Successful
        </Typography>
        <Typography
          variant="h6"
          color="success.main"
          data-testid="stat-successful"
        >
          {successfulRows}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary">
          Failed
        </Typography>
        <Typography variant="h6" color="error.main" data-testid="stat-failed">
          {failedRows}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary">
          Processed
        </Typography>
        <Typography variant="h6" data-testid="stat-processed">
          {processedRows} / {totalRows}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProgressStats;
